import { Chakra } from "@airhelp/react-ui-components";

const { Box } = Chakra;

export interface SpacerProps {
  hDesktop: string;
  hMobile: string;
}

const Spacer = ({ hDesktop, hMobile }: SpacerProps) => <Box h={{ base: hMobile, md: hDesktop }} />

export default Spacer;
